<template>
	<v-col>
		<base-material-card>
			<template #heading>
				<v-row class="d-s-flex">
					<v-col
						cols="12"
						:class="
							$vuetify.breakpoint.smAndDown
								? 'text-center display-2 font-weight-light'
								: 'display-2 font-weight-light'
						"
					>
						לידים
					</v-col>
				</v-row>
			</template>
			<tracks-table />
		</base-material-card>
	</v-col>
</template>
<script>
import TracksTable from "./TracksTable";
export default {
	name: "Tracks",
	components: { TracksTable }
};
</script>
